import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	exploreMoreApps: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps',
		defaultMessage: 'Explore more apps',
		description: 'Label for "Explore more apps" link under the Apps menu of the global sidebar',
	},
});
